import React from "react";
import _data from "../../data";

function StoreButton({ href, iconClass, label }) {
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="kt-store-btn mr-2 mb-2"
    >
      <span className={iconClass} style={{ fontSize: 16 }} />
      <span className="ml-2">{label}</span>
    </a>
  );
}

function ScreenshotGrid({ screenshots, appName }) {
  if (!screenshots || screenshots.length === 0) return null;
  return (
    <div className="kt-screenshot-grid mt-3">
      {screenshots.slice(0, 4).map((src, idx) => (
        <a
          key={`${appName}-shot-${idx}`}
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="kt-shot"
          aria-label={`${appName} screenshot ${idx + 1}`}
        >
          <img src={src} alt={`${appName} screenshot ${idx + 1}`} />
        </a>
      ))}
    </div>
  );
}

export default class AppsShowcase extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { apps: null };
  }

  componentDidMount() {
    this.setState({ apps: _data.apps });
  }

  render() {
    const apps = this.state.apps;
    if (!apps) return null;

    return (
      <section id="apps" className="ptb-100 gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-heading text-center mb-5">
                <h2>{apps.title}</h2>
                <p className="lead">{apps.description}</p>
                <div className="d-flex flex-wrap justify-content-center mt-3">
                  <StoreButton
                    href={apps.developerLinks.googlePlay}
                    iconClass="ti-android"
                    label="Google Play"
                  />
                  <StoreButton
                    href={apps.developerLinks.appStore}
                    iconClass="ti-apple"
                    label="App Store"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {(apps.items || []).map((app) => (
              <div className="col-md-6 col-lg-6 mb-4" key={app.name}>
                <div className="kt-app-card white-bg p-4 h-100">
                  <div className="d-flex align-items-start">
                    <div className="kt-app-icon mr-3">
                      <img
                        src={app.image}
                        alt={app.name}
                        className="img-fluid"
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h5 className="mb-2 kt-truncate">{app.name}</h5>
                      <p className="mb-3 text-muted">{app.description}</p>
                      <div className="d-flex flex-wrap">
                        <StoreButton
                          href={app.googlePlay}
                          iconClass="ti-android"
                          label="Google Play"
                        />
                        <StoreButton
                          href={app.appStore}
                          iconClass="ti-apple"
                          label="App Store"
                        />
                      </div>

                      <ScreenshotGrid
                        screenshots={app.screenshots}
                        appName={app.name}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

